export default "__VITE_ASSET__f49f22a9__"